import colors from './colors'
import fonts from './fonts'

const menus = {
    contextMenu: {
        padding: '20px 16px',
    },
}

const scrollable = {
    overflow: 'scroll',
    WebkitOverflowScrolling: 'touch',
}

const titledList = {
    container: Object.assign({}, menus.contextMenu, {
        position: 'absolute',
        padding: '0',
        background: colors.grey_1,
        borderRadius: '4.8px',
        width: '182px',
        display: 'inline-block',
        height: '100%',
        overflow: 'scroll',
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.5)',
    }),
    title: Object.assign({}, menus.contextMenu, {
        color: colors.white,
    }),
    titleLabel: {
        fontSize: '1.2em',
        textAlign: 'center',
    },
    item: Object.assign({}, menus.contextMenu, {
        position: 'relative',
        height: '1.48em',
        color: colors.darkWhite,
    }),
    currentItem: {
        color: colors.white,
    },
    label: {
        fontSize: '1.2em',
    },
    scroller: Object.assign({}, scrollable, {
        overflow: 'scroll',
    }),
}

const darkContextMenu = Object.assign({}, titledList, {
    container: Object.assign({}, titledList.container, {
        width: '9.1em',
    }),
    title: Object.assign({}, titledList.title, {
        boxShadow: '0 0.2em 0.4em 0 rgba(0,0,0,0.5)',
    }),
    scroller: Object.assign({}, titledList.scroller, {
        //maxHeight = height * numberOfElementsToshow
        maxHeight: 69.6 * 3,
    }),
})

const darkContextMenuDesktop = Object.assign({}, titledList, {
    container: Object.assign({}, titledList.container, {
        width: '6.10em',
    }),
    title: Object.assign({}, titledList.title, {
        boxShadow: '0 0.2em 0.4em 0 rgba(0,0,0,0.5)',
        height: '1em',
        position: 'relative',
        padding: '10px 16px',
    }),
    scroller: Object.assign({}, titledList.scroller, {
        //maxHeight = height * numberOfElementsToshow
        maxHeight: 69.6 * 3,
    }),
    titleLabel: Object.assign({}, titledList.titleLabel, {
        fontSize: '0.9em',
        fontWeight: 'lighter',
        textAlign: 'center',
        width: '100%',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
    }),
    label: Object.assign({}, titledList.label, {
        fontSize: '0.9em',
        fontWeight: 'lighter',
        cursor: 'pointer',
    }),
    item: Object.assign({}, titledList.item, {
        height: '1.28em',
        padding: '10px 16px',
        cursor: 'pointer',
        ':hover': {
            color: '#fff',
            background: colors.grey_9,
        },
    }),
    currentItem: {
        color: '#fff',
        background: colors.grey_0,
    },
})

const contextMenu = {
    dark: darkContextMenu,
    darkDesktop: darkContextMenuDesktop,
    share: Object.assign({}, darkContextMenu, {
        container: Object.assign({}, titledList.container, {
            width: '9.4em',
            height: '13.95em',
        }),
        item: Object.assign({}, titledList.item, {
            display: 'inline-block',
            width: '4.7em',
            height: '4.65em',
            padding: 0,
            float: 'left',
            fontSize: '1em',
            background: 'transparent',
            border: 'none',
            borderWidth: '0',
        }),
        scroller: Object.assign({}, titledList.scroller, {
            maxHeight: 'auto',
        }),
    }),
}

const contextMenuDesktop = {
    dark: darkContextMenuDesktop,
    share: Object.assign({}, darkContextMenu, {
        container: Object.assign({}, titledList.container, {
            width: '5.4em',
            height: '8.4em',
        }),
        item: Object.assign({}, titledList.item, {
            display: 'inline-block',
            width: '2.7em',
            height: '2.8em',
            padding: 0,
            float: 'left',
            fontSize: '1em',
            background: 'transparent',
            border: 'none',
            borderWidth: '0',
            cursor: 'pointer',
        }),
        scroller: Object.assign({}, titledList.scroller, {
            maxHeight: 'auto',
        }),
    }),
}

export default {
    contextMenu,
    contextMenuDesktop,
    scrollable,
    stopslist: Object.assign({}, titledList, {
        container: Object.assign({}, titledList.container, {
            position: 'relative',
            width: '100%',
            height: '100%',
            background: '#252e40',
            backgroundImage: colors.grey_2_1_gradient,
        }),
        title: Object.assign({}, titledList.title, {
            padding: 0,
            position: 'relative',
        }),
        item: Object.assign({}, titledList.item, {
            padding: '1.225em 1em',
            height: '164px',
            boxShadow: '0 4px 14px 0 rgba(0, 0, 0, 0.5)',
            borderRadius: '4px',
            backgroundSize: 'cover',
            color: colors.white,
            display: 'flex',
        }),
        label: Object.assign({}, titledList.label, {
            width: 'calc(100% - 2em)',
            textShadow: '0 2px 10px rgba(0,0,0,0.7)',
            fontWeight: '500',
            textAlign: 'left',
            display: 'block',
            position: 'absolute',
            bottom: '12px',
            left: '27px',
            textOverflow: 'ellipsis',
            alignSelf: 'flex-end',
        }),
        titleLabel: Object.assign({}, titledList.titleLabel, {
            fontSize: '1.6em',
            fontWeight: 600,
        }),
        scroller: Object.assign({}, titledList.scroller, {
            overflow: 'scroll',
            marginTop: '57px',
        }),
    }),
}
